{
  "ASSISTANT_NOT_CONFIGURED": "El asistente aún no está configurado en esta área",
  "ASSISTANT_CONVERSATION_NOT_FOUND": "Conversación no encontrada",
  "ASSISTANT_CONVERSATION_DELETED": "Conversación eliminada",
  "ASSISTANT_MESSAGE_REQUIRED": "Escribe un mensaje o adjunta un archivo",
  "ASSISTANT_RUN_IN_PROGRESS": "El asistente todavía está respondiendo en esta conversación",
  "ASSISTANT_RUN_FAILED": "El asistente tuvo un problema al responder",
  "ASSISTANT_APPROVAL_NOT_PENDING": "Esta confirmación ya no está pendiente",
  "ASSISTANT_UPLOAD_NOT_FOUND": "Archivo no encontrado en esta conversación",
  "ASSISTANT_UPLOAD_TYPE_INVALID": "Tipo de archivo no aceptado",
  "ASSISTANT_UPLOAD_TOO_LARGE": "El archivo supera el tamaño permitido",
  "ASSISTANT_UPLOAD_INCOMPLETE": "El archivo todavía no terminó de subir",
  "ASSISTANT_UPLOAD_NOT_RETRYABLE": "Este archivo ya fue recibido",
  "ASSISTANT_UPLOAD_FAILED": "No fue posible procesar el archivo"
}
